var map = {
  "./CTTY_00.svg": "39191",
  "./CTTY_01.svg": "33862",
  "./CTTY_02.svg": "65637",
  "./CTTY_03.svg": "68388",
  "./CTTY_04.svg": "52331",
  "./CTTY_05.svg": "58458",
  "./CTTY_06.svg": "3273",
  "./CTTY_07.svg": "94264",
  "./CTTY_08.svg": "4479",
  "./CTTY_09.svg": "89838",
  "./CTTY_10.svg": "79188",
  "./CTTY_12.svg": "80534",
  "./CTTY_13.svg": "43751",
  "./CTTY_14.svg": "41352",
  "./CTTY_15.svg": "37369",
  "./CTTY_18.svg": "54652",
  "./CTTY_20.svg": "52797",
  "./CTTY_21.svg": "24252",
  "./CTTY_EPUB_COLIBRIO.svg": "95679",
  "./CTTY_LTI.svg": "56348",
  "./CTTY_MINTBLOCK.svg": "1210",
  "./CTTY_VIDEOLESSON.svg": "22512",
  "./MINT_PAGE.svg": "6554",
  "./MINT_PAGE_DUAL.svg": "57031",
  "./activity.svg": "30783",
  "./audio.svg": "1182",
  "./ctty-audio.svg": "12921",
  "./ctty-general.svg": "399",
  "./ctty-image.svg": "64260",
  "./ctty-link.svg": "35569",
  "./ctty-video.svg": "478",
  "./default.svg": "2095",
  "./icon-active-circle.svg": "6279",
  "./icon-add-circle.svg": "82738",
  "./icon-add-image.svg": "52641",
  "./icon-add-square.svg": "72471",
  "./icon-add.svg": "71141",
  "./icon-analytic.svg": "77565",
  "./icon-archive.svg": "51822",
  "./icon-arrow-circle-left.svg": "91406",
  "./icon-arrow-circle-right.svg": "46541",
  "./icon-arrow-down.svg": "23948",
  "./icon-arrow-left.svg": "61627",
  "./icon-arrow-right.svg": "50558",
  "./icon-arrow-square-down.svg": "65850",
  "./icon-arrow-square-left.svg": "26801",
  "./icon-arrow-square-right.svg": "97756",
  "./icon-arrow-square-up.svg": "12777",
  "./icon-arrow-up.svg": "30695",
  "./icon-attach.svg": "57307",
  "./icon-book-lesson.svg": "9288",
  "./icon-bubble-background.svg": "28287",
  "./icon-calendar-check.svg": "38269",
  "./icon-calendar.svg": "29726",
  "./icon-check-empty.svg": "46184",
  "./icon-check-indeterminate.svg": "51458",
  "./icon-check.svg": "3524",
  "./icon-chevron-down.svg": "23538",
  "./icon-chevron-left.svg": "57683",
  "./icon-chevron-right.svg": "69508",
  "./icon-chevron-up.svg": "69889",
  "./icon-close.svg": "1424",
  "./icon-color-degraded.svg": "61080",
  "./icon-color-solid.svg": "13015",
  "./icon-configuration.svg": "994",
  "./icon-content.svg": "58355",
  "./icon-copy.svg": "5099",
  "./icon-drag-dots.svg": "87295",
  "./icon-evaluation-activities.svg": "17860",
  "./icon-exit.svg": "27388",
  "./icon-external-link.svg": "98582",
  "./icon-eye.svg": "83555",
  "./icon-feedback.svg": "59873",
  "./icon-filter.svg": "44362",
  "./icon-flag.svg": "93330",
  "./icon-general-settings.svg": "1362",
  "./icon-group.svg": "44653",
  "./icon-handle.svg": "10686",
  "./icon-home-box.svg": "99885",
  "./icon-home-document.svg": "6285",
  "./icon-home-lightbulb.svg": "56303",
  "./icon-home-media.svg": "52382",
  "./icon-home-microphone.svg": "77362",
  "./icon-home-star.svg": "65446",
  "./icon-home-tools.svg": "94439",
  "./icon-home-video.svg": "67491",
  "./icon-import-mint.svg": "7076",
  "./icon-info-circle.svg": "96957",
  "./icon-info-square.svg": "90640",
  "./icon-info.svg": "58320",
  "./icon-kanban.svg": "27993",
  "./icon-lemonade-classify.svg": "3870",
  "./icon-lemonade-cloze.svg": "43099",
  "./icon-lemonade-game.svg": "78606",
  "./icon-lemonade-math.svg": "55050",
  "./icon-lemonade-multiple.svg": "99348",
  "./icon-lemonade-scheme.svg": "22885",
  "./icon-lemonade-text.svg": "30645",
  "./icon-lemonade-typing.svg": "8561",
  "./icon-lesson-vanilla.svg": "94258",
  "./icon-lesson.svg": "78624",
  "./icon-license.svg": "64965",
  "./icon-logo.svg": "30417",
  "./icon-lti.svg": "14205",
  "./icon-magic-map-off.svg": "28348",
  "./icon-magic-map.svg": "29816",
  "./icon-mapped-finished.svg": "62592",
  "./icon-mapped-hide.svg": "84474",
  "./icon-mapped-processing.svg": "10879",
  "./icon-material.svg": "82431",
  "./icon-minigame.svg": "64195",
  "./icon-mint.svg": "70556",
  "./icon-more-bullets-vertical.svg": "91434",
  "./icon-more-bullets.svg": "41611",
  "./icon-paper-plus.svg": "16291",
  "./icon-pencil-2.svg": "17190",
  "./icon-pencil.svg": "31699",
  "./icon-power-lesson.svg": "33996",
  "./icon-program.svg": "61352",
  "./icon-question.svg": "4240",
  "./icon-quiz.svg": "28527",
  "./icon-refresh.svg": "82181",
  "./icon-save.svg": "89187",
  "./icon-search.svg": "40432",
  "./icon-setting.svg": "93624",
  "./icon-success.svg": "77557",
  "./icon-task.svg": "63123",
  "./icon-teacher.svg": "70966",
  "./icon-test-evaluative.svg": "28851",
  "./icon-toast-error.svg": "55588",
  "./icon-toast-info.svg": "32118",
  "./icon-toast-success.svg": "69247",
  "./icon-toast-warning.svg": "36298",
  "./icon-trash-2.svg": "23379",
  "./icon-trash.svg": "55458",
  "./icon-tree-folder-end.svg": "73785",
  "./icon-tree-folder.svg": "98741",
  "./icon-up-arrow.svg": "48015",
  "./icon-upload-file.svg": "43314",
  "./icon-uploader.svg": "12122",
  "./icon-user-admin.svg": "8447",
  "./icon-user-link.svg": "87578",
  "./icon-user.svg": "13981",
  "./icon-version-history.svg": "58371",
  "./icon-videolesson.svg": "25425",
  "./icon-visible-off.svg": "3066",
  "./icon-visible.svg": "78890",
  "./icon-warning-circle-bold.svg": "54363",
  "./icon-warning-circle.svg": "48717",
  "./icon-warning.svg": "19520",
  "./image.svg": "38911",
  "./link.svg": "82056",
  "./link2.svg": "96778",
  "./lock-open.svg": "25986",
  "./lock.svg": "69181",
  "./map_es.svg": "78865",
  "./misc.svg": "4592",
  "./move-down.svg": "94084",
  "./move-up.svg": "24703",
  "./programming.svg": "52551",
  "./test.svg": "96028",
  "./video.svg": "9161",
  "./videolessons.svg": "18876"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 42449;
